import { queryOptions, useQuery } from '@tanstack/react-query';
import { useMemo, useState } from 'react';
import { Address, zeroAddress } from 'viem';

import { teamMemberQuery } from './teamMemberQuery';

export const useTeamMemberQuery = (leaderAddress?: Address, size?: number) => {
  const [page, setPage] = useState(1);
  const reactQueryOptions = useMemo(() => {
    const param = {
      userAddress: leaderAddress?.toLowerCase() ?? zeroAddress,
      page: page - 1,
      size: size ?? 10,
    };
    
return queryOptions({
      queryKey: teamMemberQuery.getKey(param),
      queryFn: teamMemberQuery.getFn(param),
      enabled: !!leaderAddress,
    });
  }, [leaderAddress, page]);

  const query = useQuery(reactQueryOptions);

  return {
    query,
    setPage,
  };
};
